<template>
  <div id="profile-role-module" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden body-module-height">
    <bds-scroll-area component-class="content-scroll-area">
      <vx-card no-shadow v-if="loaded">
        <div class="vx-row px-6">
          <div class="vx-row w-full">
            {{ $t('pages.users.permissions.permissionTitle') }}
          </div>

          <div v-for="role in roles" :key="role.value" class="vx-col w-1/2">
            <vs-checkbox v-model="selected_roles" :vs-value="role.value" @change="triggerInput">
              {{ role.text }}
            </vs-checkbox>
          </div>

          <vs-divider>
            {{ $t('pages.users.permissions.capabilitiesTitle') }}
          </vs-divider>

          <div class="w-full">
            <!-- Can pay with physical credit card -->
            <div class="flex flex-row">
              <vs-checkbox v-model="internal_capabilities['physicalCreditCard']" @change="changeCapability"/>
              CREDIT CARD?
            </div>

            <div class="flex flex-row" v-if="hasClinic">
              <vs-checkbox v-model="internal_capabilities['clinicPartner']" @change="changeCapability"/>
              Clinica Parceira?
            </div>

            <div class="w-full flex flex-row space-x-2 items-center" v-if="hasInstructor">
              <bds-label text="Desconto para alunos vinculados " class="px-2"/>
              <vs-input-number v-model="internal_capabilities['instructorDiscount']" label="%" color="#76bb46" :min="0" :max="15"
                               @input="changeCapability"/>
            </div>

            <div class="w-full md:w-1/2 flex flex-row items-center" v-if="$store.state.Profile.isDoctor()">
              <bds-label text="Instrutor: " class="px-2"/>
              <choose-user v-model="internal_capabilities['instructorId']" role-user="instructor" class="w-32"
                           @input="changeCapability"/>
            </div>

            <div class="flex flex-row">
              <vs-checkbox v-model="internal_capabilities['dentalPrev']" @change="changeCapability"/>
              Dental Prev?
            </div>
          </div>
        </div>

        <div class="flex flex-wrap justify-end p-6">
          <vs-button class="mr-6" type="border" color="warning" @click="copyValue">
            {{ $t('buttons.reset') }}
          </vs-button>
          <vs-button @click="submitData" :disabled="!isValid">
            {{ $t('buttons.save') }}
          </vs-button>
        </div>
      </vx-card>
    </bds-scroll-area>
  </div>
</template>

<script>
import ChooseUser from "@/views/components/ChooseUser";
import {getRoles} from '@/helpers/lists';
import { DataCapabilities } from '@/models/User.model'

export default {
  name: "user-roles",
  components: {ChooseUser},
  props: {
    value: {
      type: Array,
      required: true,
    },
    capabilities: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selected_roles: [],
      internal_capabilities: {},
      loaded: false,
    }
  },
  watch: {
    value() {
      this.copyValue();
    },
    capabilities() {
      this.copyCapabilities();
    }
  },
  computed: {
    roles() {
      return getRoles();
    },
    hasClinic() {
      return this.value.includes('clinic');
    },
    hasInstructor() {
      return this.value.includes('instructor');
    }
  },
  methods: {
    copyValue() {
      this.selected_roles = [];
      for (let v of this.value) {
        this.selected_roles.push(v);
      }
    },
    copyCapabilities() {
      this.internal_capabilities = DataCapabilities.FromObj(this.capabilities);
    },
    isValid() {
      return this.selected_roles.length > 0;
    },
    resetData() {
      this.copyValue();
      this.copyCapabilities();
    },
    submitData() {
      this.$emit('submitData');
    },
    triggerInput() {
      this.$emit('input', this.selected_roles);
    },
    changeCapability() {
      this.$emit('update:capabilities', this.internal_capabilities);
    }
  },
  created() {
    this.copyValue();
    this.copyCapabilities();
    this.loaded = false;
  },
  mounted() {

    this.loaded = true;
  },
}
</script>

<style scoped>

</style>
